/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-03T15:07:15.56
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'rentmanage-rentmaterial-'

export default 
{
path: '/rentmanage/rentmaterial',
name: 'rentmanage-rentmaterial',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}rentmaterial-index',

meta:{
...meta,
title: '材料管理'
},

component: () => import('@/pages/rentmanage/rentmaterial/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}rentmaterial-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '材料管理编辑'
},

component: () => import('@/pages/rentmanage/rentmaterial/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}rentmaterialdetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '材料管理新增'
},

component: () => import('@/pages/rentmanage/rentmaterial/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}rentmaterialView',
auth: [
'hidden'
],

meta:{
...meta,
title: '材料管理详情查看'
},

component: () => import('@/pages/rentmanage/rentmaterial/detail-view') ,
},
]
};
